/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import Vue from 'vue';
import { method, render } from '../lib';
import { VmIcon } from '@vime/core';
import { define } from '../lib';
define('vm-icon', VmIcon);
export default Vue.extend({
    props: {
        name: {},
        src: {},
        label: {},
        library: {},
        icons: {},
    },
    methods: {
        redraw: method('redraw'),
    },
    render: render('vm-icon', ['vmLoad', 'vmError']),
});
//# sourceMappingURL=Icon.js.map